import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

/**
 * Reusable card that combines a labelled toggle switch with a title,
 * description, and optional projected content shown when the toggle is ON.
 *
 * Usage:
 * <app-feature-toggle-card
 *   title="My Feature"
 *   description="Short description text"
 *   [(enabled)]="myFlag">
 *   <!-- projected content visible only when enabled == true -->
 * </app-feature-toggle-card>
 */
@Component({
  selector: 'app-feature-toggle-card',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './feature-toggle-card.component.html',
  styleUrl: './feature-toggle-card.component.scss',
})
export class FeatureToggleCardComponent {
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() enabled: boolean = false;

  @Output() enabledChange = new EventEmitter<boolean>();

  onToggle(): void {
    this.enabledChange.emit(this.enabled);
  }
}
